import Button from '@ingka/button'
import Image from '@ingka/image'
import Search from '@ingka/search'
import chevronUp from '@ingka/ssr-icon/paths/chevron-up'
import favorite from '@ingka/ssr-icon/paths/heart'
import menu from '@ingka/ssr-icon/paths/menu'
import person from '@ingka/ssr-icon/paths/person'
import share from '@ingka/ssr-icon/paths/share-network'
import shoppingBag from '@ingka/ssr-icon/paths/shopping-bag'
import Head from 'next/head'

export interface MockWrapperProps {
  lang?: string
  children?: React.ReactNode
}

export const MockWrapper: React.FC<MockWrapperProps> = ({ children, lang }) => (
  <>
    {lang && (
      <Head>
        <link
          rel="stylesheet"
          href={`https://www.ikea.com/global/assets/fonts/${lang}/fonts.css`}
        />
      </Head>
    )}
    <div>
      <div className="z-[101] translate-y-full -top-[92px] transition-transform fixed left-0 right-0 bg-stone-100">
        <header
          className="flex flex-wrap justify-between items-center w-full h-[90px] bg-stone-100 z-[1] md:h-[80px]
           "
        >
          <div className="shrink-0 order-2 block py-[0.9375ren]">
            <div className="relative w-[75px] h-[30px]">
              <Image
                src="/ikea-logo.svg"
                alt="IKEA"
                className="pb-0 w-[75px] h-[30px]"
              />
            </div>
          </div>
          <div className="order-2 min-w-[600px] z-0 my-0 mx-8 hidden md:block">
            <Search id="header-search" />
          </div>
          <ul className="flex order-5 ml-auto -mr-[0.625rem] [&_li]:list-none [&_li+li]:ml-[2px]">
            <li>
              <Button
                type="tertiary"
                size="small"
                iconOnly
                ssrIcon={person}
                text="My Profile"
              />
            </li>
            <li>
              <Button
                type="tertiary"
                size="small"
                iconOnly
                ssrIcon={favorite}
                text="Shopping List"
              />
            </li>
            <li>
              <Button
                type="tertiary"
                size="small"
                iconOnly
                ssrIcon={shoppingBag}
                text="Shopping Cart"
              />
            </li>
            <li>
              <Button
                type="tertiary"
                size="small"
                iconOnly
                ssrIcon={menu}
                text="Menu"
              />
            </li>
          </ul>
        </header>
      </div>

      <main className="my-10 mx-0">
        <div>{children}</div>
      </main>
      <div className="max-w-[112rem] my-0 mx-auto py-0 px-5 box-border flex justify-center w-full border-t border-t-neutral-2 mt-8">
        <div className="py-4 px-0">
          <Button
            type="primary"
            className="my-0 mx-2 text-stone-1700 [&>*]:!bg-neutral-2"
            size="small"
            iconOnly
            ssrIcon={chevronUp}
            text="Scroll to top"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' })
            }}
          />
          <Button
            type="primary"
            className="my-0 mx-2 text-stone-1700 [&>*]:!bg-neutral-2"
            size="small"
            iconOnly
            ssrIcon={share}
            text="Social sharing"
          />
        </div>
      </div>
      <footer className="bg-neutral-2 py-16 px-0">
        <div>Footer</div>
      </footer>
    </div>
  </>
)

export default MockWrapper
